import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import NumberInputAdornments from "./NumberInputAdornments";
import CustomButton from "../../reusableComponents/CustomButton";
import CustomDropdown from "../../reusableComponents/CustomDropdown";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import SmallModal from "../../reusableComponents/modals/SmallModal";
import { useAuth } from "../../context/API_Client";
import { useEffect } from "react";
import RouteIcon from "@mui/icons-material/Route";
import { useLocation, useNavigate } from "react-router";
import { getPaymentMethodCategories, sortArrayValue } from "../utils/utils";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import LoadingLogoPage from "../loadingPage/loadingPage";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { colorBrandObject } from "../../../constants/brandings";
const RoutingConfig = () => {
  const {
    getPaymentMethod,
    addRoutingRule,
    getRoutingRules,
    editRoutingRules,
    postPspConfigForFiltering,
    getAllModalData,
    getRoutingRuleById,
  } = useAuth();

  const [businessUnitsData, setBusinessUnitsData] = useState();
  const [businessNameArr, setBusinessNameArr] = useState();
  const [businessCodeArr, setBusinessCodeArr] = useState();

  const [countryData, setCountryData] = useState();
  const [currencyData, setCurrencyData] = useState();
  const [pspData, setPspData] = useState();
  const [categoryInfo, setCategoryInfo] = useState({});
  const [paymentMethodIds, setPaymentMethodIds] = useState();
  const [allPaymentMethodsData, setAllPaymentMethodData] = useState();
  const [allPspdata, setAllPspData] = useState();

  const [selectedBusinessName, setSelectedBusinessName] = useState();
  const [selectedBusinessCode, setSelectedBusinessCode] = useState();
  const [countriesRule, setCountriesRule] = useState();
  const [currenciesRule, setCurrenciesRule] = useState();
  const [categoriesRule, setCategoriesRule] = useState();
  const [pspRule, setPspRule] = useState();
  const [secondaryPspRule, setSecondaryPspRule] = useState();
  const [percentageRule, setPercentageRule] = useState(100);
  const [secondaryPercentageRule, setSecondaryPercentageRule] = useState(100);

  const [disableSave, setDisableSave] = useState(true);
  const [secondaryProcessorEnabled, setSecondaryProcessorEnabled] =
    useState(false);

  const [confirmationModalToggle, setConfirmationModalToggle] = useState(false);
  const [noRuleIdDialog, setNoRuleIdDialog] = useState(false);
  const [invalidRuleIdDialog, setInvalidRuleIdDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const ruleId = queryParameters.get("ruleId");
  const navigate = useNavigate();
  const [percentageError1, setPercentageError1] = useState("");
  const [percentageError2, setPercentageError2] = useState("");
  // percentage error handling
  useEffect(() => {
    if (
      !secondaryProcessorEnabled &&
      !secondaryPspRule &&
      percentageRule < 100
    ) {
      setPercentageError1(
        "Please note that the percentage should be 100% to activate the rule"
      );
      setPercentageError2(
        "Please note that the percentage should be 100% to activate the rule"
      );
    } else if (
      secondaryProcessorEnabled &&
      parseInt(percentageRule) + parseInt(secondaryPercentageRule) !== 100
    ) {
      setPercentageError1(
        "Please note that the sum of percentages should be 100% to activate the rule"
      );
      setPercentageError2(
        "Please note that the sum of percentages should be 100% to activate the rule"
      );
    } else {
      if (parseInt(percentageRule) > 100) {
        handleToastForPercentage("percentage", 1);
      } else if (parseInt(percentageRule) < 1) {
        handleToastForPercentage("percentage", -1);
      } else {
        setPercentageError1("");
      }
      if (parseInt(secondaryPercentageRule) > 100) {
        handleToastForPercentage("", 1);
      } else if (parseInt(secondaryPercentageRule) < 1) {
        handleToastForPercentage("", -1);
      } else {
        setPercentageError2("");
      }

    }
  }, [percentageRule, secondaryPercentageRule, secondaryProcessorEnabled]);
  // handling disable save
  useEffect(() => {
    if (
      selectedBusinessCode &&
      pspRule &&
      (countriesRule || categoriesRule || currenciesRule)
    ) {
      if (secondaryProcessorEnabled) {
        if (secondaryPspRule) {
          if (
            parseInt(percentageRule) + parseInt(secondaryPercentageRule) !=
            100
          ) {
            setDisableSave(true);
          } else {
            setDisableSave(false);
          }
        } else {
          setDisableSave(true);
        }
      } else {
        if (parseInt(percentageRule) < 100) {
          setDisableSave(true);
        } else {
          setDisableSave(false);
        }
      }
    } else {
      setDisableSave(true);
    }
  }, [
    pspRule,
    countriesRule,
    currenciesRule,
    categoriesRule,
    percentageRule,
    secondaryPercentageRule,
    secondaryPspRule,
    secondaryProcessorEnabled,
  ]);

  useEffect(() => {
    getPaymentMethod(
      function (data) {
        setAllPaymentMethodData(data);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    getAllModalData(
      function (data) {
        setAllPspData(data?.pspCodes);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  useEffect(() => {
    if (paymentMethodIds && allPaymentMethodsData) {
      let categoryArr = getPaymentMethodCategories(
        paymentMethodIds,
        allPaymentMethodsData
      );
      categoryArr = sortArrayValue(categoryArr, "name")

      setCategoryInfo(categoryArr);
    }
  }, [paymentMethodIds, allPaymentMethodsData]);

  useEffect(() => {
    if (allPaymentMethodsData) {
      postPspConfigForFiltering(
        {},
        function (data) {
          let names = [];
          let codes = [];
          setBusinessUnitsData(data?.legalEntities);
          for (let i = 0; i < data?.legalEntities?.length; i++) {
            codes.push(data?.legalEntities[i]?.code);
            names.push(data?.legalEntities[i]?.name);
          }
          // if(names?.length) names = sortArrayValue(names)
          setBusinessNameArr(names);
          setBusinessCodeArr(codes);
          if (ruleId) {
            getRoutingRuleById(
              ruleId,
              function (previousRuleData) {
                const businessUnit_prev = data?.legalEntities?.find(
                  (ele) => ele?.code === previousRuleData?.legalEntityCode
                );
                setSelectedBusinessName(businessUnit_prev?.name);
                setSelectedBusinessCode(businessUnit_prev?.code);
                const psp_primary_prev = data?.pspCodes?.find(
                  (ele) => ele?.value === previousRuleData?.primary?.pspCode
                );
                const psp_secondary_prev = data?.pspCodes?.find(
                  (ele) => ele?.value === previousRuleData?.secondary?.pspCode
                );
                const countries_prev = [];
                for (
                  let i = 0;
                  i < previousRuleData?.countryCodes?.length;
                  i++
                ) {
                  countries_prev.push(
                    data?.countryCodes?.find(
                      (ele) => ele?.value === previousRuleData?.countryCodes[i]
                    )
                  );
                }
                const currencies_prev = [];
                for (
                  let i = 0;
                  i < previousRuleData?.currencyCodes?.length;
                  i++
                ) {
                  currencies_prev.push(
                    data?.currencyCodes?.find(
                      (ele) => ele?.value === previousRuleData?.currencyCodes[i]
                    )
                  );
                }
                const categories_prev = getPaymentMethodCategories(
                  previousRuleData?.paymentMethodIds,
                  allPaymentMethodsData
                );
                if (psp_secondary_prev) {
                  setSecondaryProcessorEnabled(true);
                }
                setCountriesRule(countries_prev);
                setCurrenciesRule(currencies_prev);
                setCategoriesRule(categories_prev);
                setPspRule(psp_primary_prev);
                setPercentageRule(previousRuleData?.primary?.percentage);
                setSecondaryPspRule(psp_secondary_prev);
                setSubmitClicked(true);
                setSecondaryPspError(false);
                setPspError(false);
                setSecondaryPercentageRule(
                  previousRuleData?.secondary?.percentage
                );
              },
              function (errMsg) {
                customToast("error", "high", errMsg);
              }
            );
          } else {
            setSelectedBusinessName(names[0]);
            setSelectedBusinessCode(codes[0]);
          }
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [allPaymentMethodsData]);

  // initial
  useEffect(() => {
    if (selectedBusinessCode) {
      postPspConfigForFiltering(
        {
          legalEntities: [selectedBusinessCode],
        },
        function (data) {
          setLoading(false);
          setPspData(data?.pspCodes);
          let filteredCountryCodes = []
          if (data?.countryCodes?.length) {
            filteredCountryCodes = sortArrayValue(data?.countryCodes, "title")
          }
          setCountryData(filteredCountryCodes);
          setPaymentMethodIds(data?.paymentMethodIds);

          let filteredCurrencyCodes = []

          if (data?.currencyCodes) {
            filteredCurrencyCodes = sortArrayValue(data?.currencyCodes, "value")
          }
          setCurrencyData(filteredCurrencyCodes);
        },
        function (errMsg) {
          setLoading(false);
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [selectedBusinessCode]);

  useEffect(() => {
    if (selectedBusinessCode) {
      postPspConfigForFiltering(
        handleFilteredPayload("countryRule"),
        function (data) {
          setCurrencyData(data?.currencyCodes);
          setPaymentMethodIds(data?.paymentMethodIds);
          setPspData(data?.pspCodes);
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [countriesRule]);

  useEffect(() => {
    if (selectedBusinessCode) {
      postPspConfigForFiltering(
        handleFilteredPayload("currencyRule"),
        function (data) {
          setPaymentMethodIds(data?.paymentMethodIds);
          setPspData(data?.pspCodes);
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [currenciesRule]);

  useEffect(() => {
    if (selectedBusinessCode) {
      postPspConfigForFiltering(
        handleFilteredPayload("categoryRule"),
        function (data) {
          setPspData(data?.pspCodes);
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [categoriesRule]);

  // initializing dropdowns with initail value
  const handleFilteredPayload = (id) => {
    let pspCodes = [];
    let currencyCodes = [];
    let countryCodes = [];
    let paymentMethodIds = [];
    let legalEntities = [selectedBusinessCode];

    if (pspRule) {
      pspCodes.push(pspRule?.value);
    }
    if (secondaryPspRule) {
      pspCodes.push(secondaryPspRule?.value);
    }

    for (let i = 0; i < countriesRule?.length; i++) {
      countryCodes.push(countriesRule[i]?.value);
    }

    for (let i = 0; i < currenciesRule?.length; i++) {
      currencyCodes.push(currenciesRule[i]?.value);
    }

    for (let i = 0; i < categoriesRule?.length; i++) {
      let values = categoriesRule[i]?.value;
      for (let j = 0; j < values?.length; j++) {
        paymentMethodIds.push(values[j]?.id);
      }
    }

    let filteringPayload;

    switch (id) {
      case "countryRule":
        filteringPayload = {
          countryCodes,
          legalEntities,
        };
        break;
      case "currencyRule":
        filteringPayload = {
          countryCodes,
          currencyCodes,
          legalEntities,
        };
        break;
      case "categoryRule":
        filteringPayload = {
          countryCodes,
          currencyCodes,
          paymentMethodIds,
          legalEntities,
        };
        break;
    }

    return filteringPayload;
  };

  function handlePayload() {
    const newRule = {
      currencyCodes: [],
      countryCodes: [],
      paymentMethodIds: [],
      legalEntityCode: null,
      primary: {
        pspCode: null,
        percentage: 100,
      },
      secondary: {
        pspCode: null,
        percentage: 100,
      },
      order: 1,
    };

    const currencyCodeArray = [];
    const countryCodeArray = [];
    const paymentMethodIdArray = [];

    for (let i = 0; i < countriesRule?.length; i++) {
      countryCodeArray.push(countriesRule[i]?.value);
    }

    for (let i = 0; i < currenciesRule?.length; i++) {
      currencyCodeArray.push(currenciesRule[i]?.value);
    }
    for (let i = 0; i < categoriesRule?.length; i++) {
      for (let j = 0; j < categoriesRule[i]?.value?.length; j++) {
        paymentMethodIdArray.push(categoriesRule[i]?.value[j]?.id);
      }
    }

    newRule.currencyCodes = currencyCodeArray;
    newRule.countryCodes = countryCodeArray;
    newRule.paymentMethodIds = paymentMethodIdArray;
    newRule.primary.pspCode = pspRule?.value;
    newRule.primary.percentage = percentageRule;
    newRule.legalEntityCode = selectedBusinessCode;
    if (secondaryPspRule != null && secondaryPercentageRule != null) {
      newRule.secondary.pspCode = secondaryPspRule?.value;
      newRule.secondary.percentage = secondaryPercentageRule;
    } else {
      newRule.secondary = null;
    }
    return newRule;
  }

  const handleSave = () => {
    const payload = handlePayload();
    addRoutingRule(
      payload,
      function (data) {
        navigate("/routing", {
          state: {
            type: "success",
            text: "Rule added successfully",
          },
        });
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };

  const handelEditedRuleSave = () => {
    const payload = handlePayload();
    const id = ruleId;
    editRoutingRules(
      id,
      payload,
      function (data) {
        navigate("/routing", {
          state: {
            type: "success",
            text: "Rule updated successfully",
          },
        });
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };

  const onDelete = (id, allValues, toRemove) => () => {
    if (id === "selectedCountries") {
      const newObj = allValues.filter((ele) => ele?.title !== toRemove?.title);
      updateRoutingConfig(id, newObj, "delete");
    }
    if (id === "selectedCurrencies") {
      const newObj = allValues.filter((ele) => ele?.value !== toRemove?.value);
      updateRoutingConfig(id, newObj, "delete");
    }
    if (id === "selectedCategories") {
      const newObj = allValues.filter((ele) => ele?.name !== toRemove?.name);
      updateRoutingConfig(id, newObj, "delete");
    }
  };

  const updateRoutingConfig = (id, value, operation = "add") => {
    showChangingRuleToaster(id);
    if (id === "selectedBusinessUnit") {
      setSelectedBusinessName(
        businessUnitsData?.find((ele) => ele?.code === value)?.name
      );
      setSelectedBusinessCode(value);
      setSecondaryProcessorEnabled(false);
      setCountriesRule(null);
      setCurrenciesRule(null);
      setCategoriesRule(null);
      setSecondaryPspRule(null);
      setPercentageRule(100);
      setSecondaryPercentageRule(100);
      setPspRule(null);
    } else if (operation === "delete") {
      if (id === "selectedCountries") {
        setCurrenciesRule(null);
        setCategoriesRule(null);
        setSecondaryPspRule(null);
        setPspRule(null);
        setSecondaryProcessorEnabled(false);
        setPercentageRule(100);
        setSecondaryPercentageRule(100);
      } else if (id === "selectedCurrencies") {
        setCategoriesRule(null);
        setSecondaryPspRule(null);
        setPspRule(null);
        setSecondaryProcessorEnabled(false);
        setPercentageRule(100);
        setSecondaryPercentageRule(100);
      } else if (id === "selectedCategories") {
        setSecondaryPspRule(null);
        setPspRule(null);
        setSecondaryProcessorEnabled(false);
        setPercentageRule(100);
        setSecondaryPercentageRule(100);
      }
      if (value?.length === 0 || value === "") {
        switch (id) {
          case "selectedCountries":
            setCountriesRule(null);
            break;
          case "selectedCurrencies":
            setCurrenciesRule(null);
            break;
          case "selectedPspCodes":
            setPspRule(null);
            break;
          case "selectedSecondaryPspCodes":
            setSecondaryPspRule(null);
            break;
          case "selectedCategories":
            setCategoriesRule(null);
            break;
        }
      } else {
        switch (id) {
          case "selectedCountries":
            setCountriesRule(value);
            break;
          case "selectedCurrencies":
            setCurrenciesRule(value);
            break;
          case "selectedCategories":
            setCategoriesRule(value);
            break;
          case "selectedPspCodes":
            setPspRule(value);
            break;
          case "selectedSecondaryPspCodes":
            setSecondaryPspRule(value);
            break;
        }
      }
    } else {
      if (
        id === "selectedCountries" &&
        (currenciesRule || categoriesRule || pspRule || secondaryPspRule)
      ) {
        setCurrenciesRule(null);
        setCategoriesRule(null);
        setSecondaryPspRule(null);
        setPspRule(null);
        setSecondaryProcessorEnabled(false);
        setPercentageRule(100);
        setSecondaryPercentageRule(100);
      }
      if (
        id === "selectedCurrencies" &&
        (categoriesRule || pspRule || secondaryPspRule)
      ) {
        setCategoriesRule(null);
        setSecondaryPspRule(null);
        setPspRule(null);
        setSecondaryProcessorEnabled(false);
        setPercentageRule(100);
        setSecondaryPercentageRule(100);
      }
      if (id === "selectedCategories" && (pspRule || secondaryPspRule)) {
        setSecondaryPspRule(null);
        setPspRule(null);
        setSecondaryProcessorEnabled(false);
        setPercentageRule(100);
        setSecondaryPercentageRule(100);
      }
      if (value?.length === 0 || value === "") {
        switch (id) {
          case "selectedCountries":
            setCountriesRule(null);
            break;
          case "selectedCurrencies":
            setCurrenciesRule(null);
            break;
          case "selectedPspCodes":
            setPspRule(null);
            break;
          case "selectedCategories":
            setCategoriesRule(null);
            break;
          case "selectedSecondaryPspCodes":
            setSecondaryPspRule(null);
            break;
        }
      } else {
        switch (id) {
          case "selectedCountries":
            setCountriesRule(value);
            break;
          case "selectedCurrencies":
            setCurrenciesRule(value);
            break;
          case "selectedCategories":
            setCategoriesRule(value);
            break;
          case "selectedPspCodes":
            setPspRule(value);
            break;

          case "selectedSecondaryPspCodes":
            setSecondaryPspRule(value);
            break;
          case "percentage":
            setPercentageRule(value);
            break;

          case "secondaryPercentage":
            setSecondaryPercentageRule(value);
            break;
        }
      }
    }
  };

  const handleToastForPercentage = (id, val) => {
    if (val === -1) {
      id === "percentage"
        ? setPercentageError1("percentage cannot be less than 1%")
        : setPercentageError2("percentage cannot be less than 1%");
    } else {
      id === "percentage"
        ? setPercentageError1("percentage cannot be greater than 100%")
        : setPercentageError2("percentage cannot be greater than 100%");
    }
  };

  const updateSelect = (id, val) => {
    updateRoutingConfig(id, val);
  };

  const handleConfirmationModalToggle = () => {
    setConfirmationModalToggle(!confirmationModalToggle);
  };

  const saveConfig = () => {
    if (!ruleId) {
      handleSave();
    } else {
      handelEditedRuleSave();
    }
    handleConfirmationModalToggle();
  };

  const handleNoRuleIdDialog = () => {
    setNoRuleIdDialog(false);
    navigate("/routing");
  };

  const handleInvalidRoutingIdDialog = () => {
    setInvalidRuleIdDialog(false);
    navigate("/routing");
  };

  const generateChangingRuleToasterText = (selectionRuleName) => {
    let list = [];
    if (selectionRuleName == "Business Unit") {
      if (countriesRule) list.push("Countries");
      if (currenciesRule) list.push("Currencies");
      if (categoriesRule) list.push("Categories");
      if (pspRule) list.push("Processor");
    }
    if (selectionRuleName == "Countries") {
      if (currenciesRule) list.push("Currencies");
      if (categoriesRule) list.push("Categories");
      if (pspRule) list.push("Processor");
    }
    if (selectionRuleName == "Currencies") {
      if (categoriesRule) list.push("Categories");
      if (pspRule) list.push("Processor");
    }
    if (selectionRuleName == "Categories") {
      if (pspRule) list.push("Processor");
    }
    if (list.length <= 0) return null;

    let text = `Changing ${selectionRuleName} resets `;
    if (list.length == 1) return text + `${list[0]}`;
    for (let i = 0; i < list.length; i++) {
      if (i == list.length - 1) {
        text = text + ` and ${list[i]}`;
      } else if (i == 0) {
        text = text + ` ${list[i]}`;
      } else {
        text = text + `, ${list[i]}`;
      }
    }
    return text;
  };

  const showChangingRuleToaster = (id) => {
    let text = null;

    switch (id) {
      case "selectedBusinessUnit":
        text = generateChangingRuleToasterText("Business Unit");
        text && customToast("warning", "medium", text);
        break;
      case "selectedCountries":
        text = generateChangingRuleToasterText("Countries");
        text && customToast("warning", "medium", text);

        break;
      case "selectedCurrencies":
        text = generateChangingRuleToasterText("Currencies");
        text && customToast("warning", "medium", text);
        break;
      case "selectedCategories":
        text = generateChangingRuleToasterText("Categories");
        text && customToast("warning", "medium", text);
        break;
    }
  };

  const [submitClicked, setSubmitClicked] = useState(false);
  const [pspError, setPspError] = useState(false);
  const [secondaryPspError, setSecondaryPspError] = useState(false);

  useEffect(() => {
    if (submitClicked === true) {
      if (pspRule === null || pspRule === undefined) {
        setPspError(true);
      } else {
        setPspError(false);
      }
      if (secondaryProcessorEnabled === true) {
        if (secondaryPspRule === null || secondaryPspRule === undefined) {
          setSecondaryPspError(true);
        } else {
          setSecondaryPspError(false);
        }
      } else {
        setSecondaryPspError(false);
      }
    }
  }, [submitClicked, pspRule, secondaryPspRule, secondaryProcessorEnabled]);

  const handleValidation = () => {
    setSubmitClicked(true);
    const checkingRulesData =
      countriesRule?.length || categoriesRule?.length || currenciesRule?.length;
    const isValid =
      pspError == false &&
      secondaryPspError == false &&
      percentageError1 === "" &&
      percentageError2 === "";
    if (checkingRulesData) {
      if (isValid) {
        handleConfirmationModalToggle();
      }
    } else {
      customToast(
        "warning",
        "medium",
        "Please ensure you select at least one of the following: countries, currencies, or payment categories"
      );
    }
  };

  console.log('pspRule', pspRule);

  return (
    <>
      <div className="content-wrapper" style={{ background: "white" }}>
        <section className="content">
          {loading ? (
            <LoadingLogoPage />
          ) : (
            <div className="routing-root">
              <div className="routing-root-container">
                <div className="routing-header-for-config">
                  <ContentHeader
                    firstHeading="Rule Configuration"
                    secondHeading="Please ensure you select at least one of the following: countries, currencies, or payment categories"
                    icon={<RouteIcon sx={{ color: colorBrandObject.sideBarSelectedOptionBackground }} />}
                    showTooltip={true}
                    tooltipText="Please note that for one type of configuration,only one rule can be active at a time"
                  />
                </div>

                <div className="routing-rules-root">
                  <SmallModal
                    headerText={"Info"}
                    subHeaderText={
                      "Please ensure that you've entered the correct settings for this rule - it could affect how your payments will be routed. Once you save it, the rule becomes active."
                    }
                    outlinedBtnText={"Cancel"}
                    outlinedBtnFunction={handleConfirmationModalToggle}
                    filledBtnText={"Save"}
                    filledBtnFunction={saveConfig}
                    toggleDialog={confirmationModalToggle}
                  />
                  <SmallModal
                    headerText={"Invalid Rule ID"}
                    subHeaderText={
                      "Please enter the correct Rule Id or click on the button below to go back"
                    }
                    filledBtnText={"Go Back"}
                    filledBtnFunction={handleInvalidRoutingIdDialog}
                    toggleDialog={invalidRuleIdDialog}
                  />
                  <SmallModal
                    headerText={"Rule ID not found"}
                    subHeaderText={
                      "Please checK the URL, as the transaction ID parameter is missing. Please enter the Rule ID parameter in the URL or click on the button below to go back"
                    }
                    filledBtnText={"Go Back"}
                    filledBtnFunction={handleNoRuleIdDialog}
                    toggleDialog={noRuleIdDialog}
                  />
                  {countryData &&
                    currencyData &&
                    businessUnitsData &&
                    categoryInfo && (
                      <div className="routing-rules-input">
                        <Typography className="bodyB1Medium">
                          Rule Input
                        </Typography>
                        <div className="routing-field-form">
                          <div className="routing-rules-field">
                            <InputLabel
                              className="routing-config-label"
                              required
                              style={{
                                color: colorBrandObject.primaryButtonColor,
                              }}
                            >
                              Business Unit
                            </InputLabel>
                            <div style={{ display: "flex", width: "100%" }}>
                              <div style={{ width: "100%" }}>
                                {selectedBusinessName && (
                                  <CustomDropdown
                                    width={"100%"}
                                    height={"40px"}
                                    optionsToDisplay={businessNameArr}
                                    optionsToSend={businessCodeArr}
                                    defaultValue={selectedBusinessName}
                                    dropDownId={"selectedBusinessUnit"}
                                    updateSelect={updateSelect}
                                  />
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="routing-rules-field">
                            <InputLabel
                              className="routing-config-label"
                              required={true}
                              style={{
                                color: colorBrandObject.primaryButtonColor,
                              }}
                            >
                              Countries
                            </InputLabel>
                            <div style={{ width: "100%" }}>
                              <Autocomplete
                                multiple
                                IconComponent={ArrowDropDownIcon}
                                options={countryData}
                                disableCloseOnSelect
                                value={countriesRule ? countriesRule : []}
                                isOptionEqualToValue={(option, value) =>
                                  option?.title === value?.title
                                }
                                getOptionLabel={(option) => option?.title}
                                renderOption={(props, option, { selected }) => (
                                  <li {...props} className={`${props?.className}  dropdownCheckboxItem`}>


                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          color:
                                            colorBrandObject?.secondaryButtonColor,
                                        },
                                        "&.Mui-checked": {
                                          color:
                                            colorBrandObject?.secondaryButtonColor,
                                          "& .MuiSvgIcon-root": {
                                            fill: colorBrandObject?.secondaryButtonColor,
                                          },
                                        },
                                      }}
                                      icon={icon}
                                      checkedIcon={checkedIcon}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    {option?.title}
                                  </li>
                                )}
                                renderTags={() => null}
                                onChange={(e, newValue) =>
                                  updateRoutingConfig(
                                    "selectedCountries",
                                    newValue
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    sx={{
                                      fontFamily: "Poppins",
                                      background: "white",
                                    }}
                                    placeholder="Select Countries"
                                  />
                                )}
                              />
                            </div>
                            <Box
                              mt={2}
                              sx={{
                                "& > :not(:last-child)": { marginRight: 1 },
                                "& > *": { marginBottom: 1 },

                                overflowY: "auto",
                                marginTop: "5px",
                              }}
                            >
                              {countriesRule?.map((item) => (
                                <Chip
                                  sx={{ marginBottom: 1 }}
                                  key={item?.value}
                                  label={item?.title}
                                  onDelete={onDelete(
                                    "selectedCountries",
                                    countriesRule,
                                    item
                                  )}
                                />
                              ))}
                            </Box>
                          </div>

                          <div className="routing-rules-field">
                            <InputLabel
                              className="routing-config-label"
                              required={true}
                              style={{
                                color: colorBrandObject.primaryButtonColor,
                              }}
                            >
                              Currencies
                            </InputLabel>
                            <div style={{ width: "100%" }}>
                              <Autocomplete
                                multiple
                                options={currencyData}
                                disableCloseOnSelect
                                value={currenciesRule ? currenciesRule : []}
                                isOptionEqualToValue={(option, value) =>
                                  option?.value === value?.value
                                }
                                getOptionLabel={(option) => option?.value}
                                onChange={(e, newValue) => {
                                  updateRoutingConfig(
                                    "selectedCurrencies",
                                    newValue
                                  );
                                }}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          color:
                                            colorBrandObject?.secondaryButtonColor,
                                        },
                                        "&.Mui-checked": {
                                          color:
                                            colorBrandObject?.secondaryButtonColor,
                                          "& .MuiSvgIcon-root": {
                                            fill: colorBrandObject?.secondaryButtonColor,
                                          },
                                        },
                                      }}
                                      icon={icon}
                                      checkedIcon={checkedIcon}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    {option?.value}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    hiddenLabel
                                    placeholder="Select Currencies"
                                    sx={{
                                      fontFamily: "Poppins",
                                      background: "white",
                                    }}
                                  />
                                )}
                              />
                            </div>
                            <Box
                              mt={2}
                              sx={{
                                "& > :not(:last-child)": { marginRight: 1 },
                                "& > *": { marginBottom: 1 },

                                overflowY: "auto",
                                marginTop: "5px",
                              }}
                            >
                              {currenciesRule?.map((item) => (
                                <Chip
                                  sx={{ marginBottom: 1 }}
                                  key={item?.value}
                                  label={item?.value}
                                  onDelete={onDelete(
                                    "selectedCurrencies",
                                    currenciesRule,
                                    item
                                  )}
                                />
                              ))}
                            </Box>
                          </div>

                          <div className="routing-rules-field">
                            <InputLabel
                              className="routing-config-label"
                              required={true}
                              style={{
                                color: colorBrandObject.primaryButtonColor,
                              }}
                            >
                              Categories
                            </InputLabel>
                            <div style={{ width: "100%" }}>
                              <Autocomplete
                                multiple
                                options={categoryInfo}
                                disableCloseOnSelect
                                value={categoriesRule ? categoriesRule : []}
                                isOptionEqualToValue={(option, value) =>
                                  option?.name === value?.name
                                }
                                getOptionLabel={(option) => option?.name}
                                onChange={(e, newValue) => {
                                  updateRoutingConfig(
                                    "selectedCategories",
                                    newValue
                                  );
                                }}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          color:
                                            colorBrandObject?.secondaryButtonColor,
                                        },
                                        "&.Mui-checked": {
                                          color:
                                            colorBrandObject?.secondaryButtonColor,
                                          "& .MuiSvgIcon-root": {
                                            fill: colorBrandObject?.secondaryButtonColor,
                                          },
                                        },
                                      }}
                                      icon={icon}
                                      checkedIcon={checkedIcon}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    {option?.name}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    hiddenLabel
                                    placeholder="Select Payment Categories"
                                    sx={{
                                      fontFamily: "Poppins",
                                      background: "white",
                                    }}
                                  />
                                )}
                              />
                              <Box
                                mt={2}
                                sx={{
                                  "& > :not(:last-child)": { marginRight: 1 },
                                  "& > *": { marginBottom: 1 },

                                  overflowY: "auto",
                                  marginTop: "5px",
                                }}
                              >
                                {categoriesRule?.map((item) => (
                                  <Chip
                                    sx={{ marginBottom: 1 }}
                                    key={item?.type}
                                    label={item?.name}
                                    onDelete={onDelete(
                                      "selectedCategories",
                                      categoriesRule,
                                      item
                                    )}
                                  />
                                ))}
                              </Box>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {pspData && (
                    <div
                      className="routing-rules-output"
                      style={{ marginTop: "32px" }}
                    >
                      <Typography className="bodyB1Medium">
                        Rule Output
                      </Typography>
                      <div className="routing-field-form">
                        <div className="routing-rules-field">
                          <InputLabel
                            className="routing-config-label"
                            required
                            style={{
                              color: colorBrandObject.primaryButtonColor,
                            }}
                          >
                            Processor
                          </InputLabel>
                          <div style={{ width: "100%" }}>
                            <Autocomplete
                              multiple={false}
                              name="selectedPspCodes"
                              options={pspData}
                              required={true}
                              value={pspRule ? pspRule : null}
                              isOptionEqualToValue={(option, value) =>
                                option?.title === value?.title
                              }
                              getOptionLabel={(option) => option.title}
                              onChange={(e, newValue) => {
                                updateRoutingConfig(
                                  "selectedPspCodes",
                                  newValue
                                );
                              }}
                              renderOption={(props, option, { selected }) =>
                                option?.title === secondaryPspRule?.title ? (
                                  <></>
                                ) : (
                                  <li {...props}>{option?.title}</li>
                                )
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  hiddenLabel
                                  placeholder="Select Processor"
                                  sx={{
                                    fontFamily: "Poppins",
                                    background: "white",
                                  }}
                                />
                              )}
                            />
                          </div>
                          {pspError && (
                            <p
                              className="error"
                              style={{
                                color: "#B9232F",
                                fontSize: "10px",
                                marginTop: "2px",
                              }}
                            >
                              <img
                                src="/assets/errorOutline.svg"
                                style={{
                                  height: "12px",
                                  width: "12px",
                                  marginTop: "2px",
                                }}
                              />{" "}
                              {"Processor is required"}
                            </p>
                          )}
                          {pspData?.length > 1 && (
                            <div
                              className={`connecting-line ${secondaryProcessorEnabled && "to-be-hidden-line"
                                }`}
                            ></div>
                          )}
                          {pspData?.length > 1 &&
                            !secondaryProcessorEnabled && (
                              <div className="new-processor-btn">
                                <AddCircleOutlineOutlinedIcon
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    color: "rgba(64, 62, 159, 1)",
                                  }}
                                  onClick={() => {
                                    setSecondaryProcessorEnabled(true);
                                    setSubmitClicked(false);
                                    setSecondaryPspError(false);
                                  }}
                                />
                                <Typography
                                  className="new-processor-typo"
                                  onClick={() => {
                                    setSecondaryProcessorEnabled(true);
                                    setSubmitClicked(false);
                                    setSecondaryPspError(false);
                                    setPercentageRule(99);
                                    setSecondaryPercentageRule(1);
                                  }}
                                >
                                  Add Payment Processor
                                </Typography>
                              </div>
                            )}
                        </div>
                        <div className="routing-rules-field">
                          <InputLabel
                            className="routing-config-label"
                            required
                            style={{
                              color: colorBrandObject.primaryButtonColor,
                            }}
                          >
                            Percentage %
                          </InputLabel>
                          <div style={{ width: "100%" }}>
                            <NumberInputAdornments
                              className="percentageInput"
                              updateNumberInput={updateRoutingConfig}
                              defaultValue={percentageRule}
                              id={"percentage"}
                              min={1}
                              max={100}
                              disabled={!pspRule}
                              handleToast={handleToastForPercentage}
                            />
                          </div>
                          {percentageError1 && (
                            <div className="percentage-error">
                              <ErrorOutlineIcon />
                              <Typography>{percentageError1}</Typography>
                            </div>
                          )}
                        </div>
                        <div className="routing-rules-field to-be-hidden"></div>
                        {pspData?.length > 1 && secondaryProcessorEnabled && (
                          <>
                            <div className="routing-rules-field">
                              <InputLabel
                                className="routing-config-label"
                                required
                                style={{
                                  color: colorBrandObject.primaryButtonColor,
                                }}
                              >
                                Processor
                              </InputLabel>
                              <div style={{ width: "100%" }}>
                                <Autocomplete
                                  multiple={false}
                                  options={pspData}
                                  required={true}
                                  value={
                                    secondaryPspRule ? secondaryPspRule : null
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option?.title === value?.title
                                  }
                                  getOptionLabel={(option) => option?.title}
                                  onChange={(e, newValue) => {
                                    updateRoutingConfig(
                                      "selectedSecondaryPspCodes",
                                      newValue
                                    );
                                  }}
                                  renderOption={(props, option, { selected }) =>
                                    option?.title === pspRule?.title ? (
                                      <></>
                                    ) : (
                                      <li {...props}>{option?.title}</li>
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      hiddenLabel
                                      placeholder="Select Processor"
                                      sx={{
                                        fontFamily: "Poppins",
                                        background: "white",
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              {secondaryPspError && (
                                <p
                                  className="error"
                                  style={{
                                    color: "#B9232F",
                                    fontSize: "10px",
                                    marginTop: "2px",
                                  }}
                                >
                                  <img
                                    src="/assets/errorOutline.svg"
                                    style={{
                                      height: "12px",
                                      width: "12px",
                                      marginTop: "2px",
                                    }}
                                  />{" "}
                                  {"Secondary Processor is required"}
                                </p>
                              )}
                              {pspData?.length > 1 && (
                                <div
                                  className={`connecting-line ${secondaryProcessorEnabled &&
                                    "to-be-hidden-line"
                                    }`}
                                ></div>
                              )}
                              {pspData?.length > 1 &&
                                secondaryProcessorEnabled && (
                                  <div className="new-processor-btn">
                                    <RemoveCircleOutlineIcon
                                      style={{
                                        height: "20px",
                                        width: "20px",
                                        color: "rgba(64, 62, 159, 1)",
                                      }}
                                      onClick={() => {
                                        updateRoutingConfig(
                                          "selectedSecondaryPspCodes",
                                          null
                                        );
                                        setSecondaryProcessorEnabled(false);
                                      }}
                                    />
                                    <Typography
                                      className="new-processor-typo"
                                      onClick={() => {
                                        updateRoutingConfig(
                                          "selectedSecondaryPspCodes",
                                          null
                                        );
                                        setSecondaryProcessorEnabled(false);
                                        setPercentageRule(100);
                                      }}
                                    >
                                      Remove Payment Processor
                                    </Typography>
                                  </div>
                                )}
                            </div>

                            <div className="routing-rules-field">
                              <InputLabel
                                className="routing-config-label"
                                required={false}
                                style={{
                                  color: colorBrandObject.primaryButtonColor,
                                }}
                              >
                                Percentage %
                              </InputLabel>
                              <div style={{ width: "100%" }}>
                                <NumberInputAdornments
                                  className="percentageInput"
                                  updateNumberInput={updateRoutingConfig}
                                  defaultValue={secondaryPercentageRule}
                                  disabled={!secondaryPspRule}
                                  id={"secondaryPercentage"}
                                  min={1}
                                  max={100}
                                  handleToast={handleToastForPercentage}
                                />
                              </div>
                              {percentageError2 && (
                                <div className="percentage-error">
                                  <ErrorOutlineIcon />
                                  <Typography>{percentageError2}</Typography>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="routing-rules-btn">
                    <CustomButton
                      variant={"outlined"}
                      type={"primary"}
                      size={"sm"}
                      text={"Cancel"}
                      onClick={() => navigate("/routing")}
                    />
                    <CustomButton
                      variant={"contained"}
                      text={"Save"}
                      type={"primary"}
                      size={"sm"}
                      onClick={handleValidation}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default RoutingConfig;
